"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextLoader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class TextLoader extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '.'
    };
  }
  componentDidMount() {
    const {
      interval
    } = this.props;
    this.interval = setInterval(() => {
      this.setState(prevState => {
        if (prevState.value === '.') {
          prevState.value = '..';
        } else if (prevState.value === '..') {
          prevState.value = '...';
        } else if (prevState.value === '...') {
          prevState.value = '.';
        }
        return prevState;
      });
    }, interval);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  render() {
    const {
      value
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("span", null, value);
  }
}
exports.TextLoader = TextLoader;
_defineProperty(TextLoader, "propTypes", {
  interval: _propTypes.default.number
});
_defineProperty(TextLoader, "defaultProps", {
  interval: 750
});
var _default = exports.default = TextLoader;
//# sourceMappingURL=TextLoader.js.map